import { render, staticRenderFns } from "./AdsetTableOfBudget.vue?vue&type=template&id=45dc7ffa&"
import script from "./AdsetTableOfBudget.vue?vue&type=script&lang=ts&"
export * from "./AdsetTableOfBudget.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports